import styles from "./css/styles.module.css";

const EachPersonalField = (props: any) => {
  const {
    label,
    name,
    value,
    style,
    isTextArea,
    isDisabled,
    onChange,
    hasDisability,
  } = props;
  const compStyle = style ? style : {};

  return (
    <div
      style={{
        borderBottom: "1px solid #E2E4E8",
        padding: "0px 10px 5px ",
        display: "grid",
        flexDirection: "column",
        gap: "5px",
        color: "#666666",
        ...compStyle,
      }}
    >
      <span style={{ fontWeight: "bold", color: "#232323" }}>{label}</span>
      {!hasDisability && (
        <>
          {isTextArea ? (
            <textarea
              name={name}
              value={value}
              rows={4}
              disabled={isDisabled}
            ></textarea>
          ) : (
            <input
              type="text"
              name={name}
              value={value}
              onChange={onChange}
              className={styles.inputStyle}
              disabled={isDisabled}
            />
          )}
        </>
      )}

      {hasDisability && <div>{value}</div>}
    </div>
  );
};

export default EachPersonalField;
